import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../Icon";
import { CONSULTING_SERVICE as C } from "../content";
import { CtaBand, PageHero, SectionHead, useSeo } from "../ui";

const contactTo = `/contact?type=${encodeURIComponent(C.inquiryType)}`;

export default function ConsultingService() {
  useSeo({
    title: "개발지원 서비스 — 회로 · PCB · 펌웨어 · 서버 개발 컨설팅 | I.META",
    description:
      "직접 개발을 진행하지 않는 개발 컨설팅 서비스. 회로 · PCB · 펌웨어 · 서버 설계 검토, 기술 방향 · 부품 선정 자문, 외주 개발사 사양서 · 견적 검토, 문제 원인 진단. 하드웨어 개발 컨설팅 I.META.",
    path: "/services/consulting",
  });

  return (
    <>
      <PageHero kicker="개발지원 서비스" title={C.headline} desc={C.lead}>
        <div className="hero__actions">
          <Link to={contactTo} className="btn btn--primary">
            컨설팅 문의 <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
          </Link>
        </div>
      </PageHero>

      <section className="section section--tight">
        <SectionHead kicker="AREAS" title="컨설팅 분야" />
        <ul className="tech-grid tech-grid--4">
          {C.areas.map((a) => {
            const I = Icon[a.icon];
            return (
              <li key={a.label} className="tech-grid__item">
                <span className="tech-grid__icon">
                  {I ? <I width="18" height="18" aria-hidden="true" focusable="false" /> : null}
                </span>
                {a.label}
              </li>
            );
          })}
        </ul>
      </section>

      <section className="section">
        <SectionHead kicker="WHAT WE DO" title="이런 일을 돕습니다" />
        <ul className="checklist checklist--row">
          {C.items.map((t) => (
            <li key={t}>
              <Icon.Check width="15" height="15" aria-hidden="true" focusable="false" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
        <p className="note-line">
          {C.note} <Link to="/partnership">제품개발 서비스 보기</Link>
        </p>
      </section>

      <CtaBand title={C.headline} to={contactTo} label="컨설팅 문의" />
    </>
  );
}
